import React, { useState } from 'react';
import { Button, Modal, Form } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import rangePickerConfig from '@/constants/default-timestamp';
import RangePicker from '@/form-component/range-picker';
import { getDomain, HD_API_DOMAIN } from '@/env';
import { prefixCls } from '@/constants';

export default () => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [disable, setDisable] = useState(true);

  const showModal = () => {
    setVisible(true);
  };
  const handleOk = () => {
    const values = form.getFieldValue('activityTime');
    const startTime = values[0].valueOf();
    const endTime = values[1].valueOf();
    const url = `activityPlan/downloadActivityPlan?startTime=${startTime}&endTime=${endTime}`;
    window.location.href = HD_API_DOMAIN + '/' + url;
    handleCancel();
  };

  const handleCancel = () => {
    setVisible(false);
    setDisable(true);
  };

  const onTimeChange = (val) => {
    !val.length ? setDisable(true) : setDisable(false);
  };
  return (
    <div className="activity-download">
      <Button shape="round" onClick={showModal}>
        <DownloadOutlined />
        导出excel
      </Button>
      <Modal
        title="活动信息导出"
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={600}
        destroyOnClose
        okButtonProps={{ disabled: disable }}
      >
        <Form form={form} preserve={false}>
          <Form.Item
            name="activityTime"
            label="选择活动开始时间范围"
            rules={[{ type: 'array', required: true, message: '活动时间不能为空' }]}
          >
            <RangePicker
              onChange={onTimeChange}
              {...rangePickerConfig}
              className={prefixCls + '-picker-full-size'}
              placeholder={['开始时间', '结束时间']}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
